import { isValidHexColor } from "components/PageBuilder/PageBuilderSideBar/BlockSettings/domain";
import { ButtonStyles, ShadowPosition } from "containers/PageBuilder/SinglePageContainer/domain";
import styled from "styled-components";
import miscUtils from "utils/miscUtils";

const BlockButton: any = styled.button<{
    design: any, 
    pageStyles: any,
    customStyles?: any,
}>`
    width: ${(props: any) => 
        props.customStyles &&
        props.customStyles.width ?
        props.customStyles.width : 
        'fit-content'
    };
    white-space: ${(props: any) => 
        props.customStyles &&
        props.customStyles.whiteSpace ?
        props.customStyles.whiteSpace :
        'pre-wrap'
    };
    transition: .5s;
    margin-top: ${(props: any) => 
        props.customStyles &&
        props.customStyles.marginTop ?
        props.customStyles.marginTop :
        '20px'
    };
    padding: ${(props: any) => 
        props.customStyles &&
        props.customStyles.padding ?
        props.customStyles.padding :
        '14px 24px'
    };

    font-weight: 700;

    background-color: ${(props: any) => 
        props.pageStyles.button.button_style === ButtonStyles.Line ?
        'transparent' :
        props.design.button_background_color &&
        isValidHexColor(props.design.button_background_color) ?
        props.design.button_background_color :
        '#EE8F00'
    };
    color: ${(props: any) => 
        props.design.button_text_color &&
        isValidHexColor(props.design.button_text_color) ?
        props.design.button_text_color :
        '#FFFFFF'
    };
    border: ${(props: any) => 
        props.pageStyles.button.button_style === ButtonStyles.Line ?
        props.design.button_background_color &&
        isValidHexColor(props.design.button_background_color) ?
        `1px solid ${props.design.button_background_color}` :
        `1px solid #EE8F00` :
        `1px solid transparent`
    };
    border-radius: ${(props: any) => 
        props.design.button_border_radius &&
        props.design.button_border_radius <= 30 ?
        `${props.design.button_border_radius}px`:
        `0px`
    };
    border-width: ${(props: any) => 
        props.design.button_border_width ?
        `${props.design.button_border_width}px` :
        `0px`
    };
    border-color: ${(props: any) => 
        props.design.button_border_color &&
        isValidHexColor(props.design.button_border_color) ?
        props.design.button_border_color :
        `transparent`
    };
    font-size: ${(props: any) => 
        props.design.button_text_font_size &&
        props.design.button_text_font_size <= 18 ?
        `${props.design.button_text_font_size}px` :
        props.pageStyles.button.button_text_font_size &&
        props.pageStyles.button.button_text_font_size <= 18 ?
        `${props.pageStyles.button.button_text_font_size}px` :
        `16px`
    };
    line-height: ${(props: any) => 
        props.design.button_text_line_height &&
        props.design.button_text_line_height <= 22 ?
        `${props.design.button_text_line_height}px` :
        props.pageStyles.button.button_text_line_height &&
        props.pageStyles.button.button_text_line_height <= 22 ?
        `${props.pageStyles.button.button_text_line_height}px` :
        `20px`
    };
    font-family: ${(props: any) =>
        props.design.button_text_font_family ?
        props.design.button_text_font_family :
        props.pageStyles.button.button_text_font_family  ?
        props.pageStyles.button.button_text_font_family :
        `-apple-system, Arial !important`
    };
    background-image: ${(props: any) => 
        props.pageStyles.button.button_style === ButtonStyles.Gradient ?
        `linear-gradient(to top, rgba(0, 0, 0, .3), ${
            props.design.button_background_color &&
            isValidHexColor(props.design.button_background_color) ?
            props.design.button_background_color :
            '#EE8F00'
        })` :
        'none'
    };
    box-shadow: ${(props: any) => 
        props.design.button_shadow_color &&
        isValidHexColor(props.design.button_shadow_color) ?
        props.design.button_shadow_position === ShadowPosition.Even ?
        `0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        props.design.button_shadow_position === ShadowPosition.Bottom ?
        `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        props.design.button_shadow_position === ShadowPosition.Top ?
        `0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        props.design.button_shadow_position === ShadowPosition.BottomRight ?
        `2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        props.design.button_shadow_position === ShadowPosition.BottomLeft ?
        `-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        props.design.button_shadow_position === ShadowPosition.TopRight ?
        `2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        props.design.button_shadow_position === ShadowPosition.TopLeft ?
        `-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.button_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.button_shadow_color)!.b}, ${props.design.button_shadow_opacity ? props.design.button_shadow_opacity : 0.0})` :
        'none'
        :
        'none'
    };

    &:hover {
        color: ${(props: any) => 
            props.pageStyles.button.button_hover_text_color &&
            isValidHexColor(props.pageStyles.button.button_hover_text_color) ?
            props.pageStyles.button.button_hover_text_color :
            props.design.button_text_color &&
            isValidHexColor(props.design.button_text_color) ?
            props.design.button_text_color :
            '#FFFFFF'
        };
    }
`;

export default BlockButton;